export class UIDValuesSceneController {
    hide() {
        this.valuesSceneContainerDiv.classList.add('hidden');
    }
    show() {
        this.valuesSceneContainerDiv.classList.remove('hidden');
        this.sidebarController.deactivateAllButtons();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.valuesSceneContainerDiv = document.getElementById('scene_discord_values_container');
    }
}
